var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bar-chart__Property 1=Bar Chart",
    className: "bar-chart__Property bar-chart__1=Bar bar-chart__Chart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bar-chart__Vector",
    className: "bar-chart__Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0054EC",
    fillOpacity: 0.16,
    d: "M21.968 2.797h-4.495a.2.2 0 0 0-.2.2v18.009c0 .11.09.2.2.2h4.495a.2.2 0 0 0 .2-.2V2.996a.2.2 0 0 0-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#011E60",
    d: "M17.523 20.956h4.395V3.046h-4.395v17.91Zm4.895.05a.45.45 0 0 1-.45.45h-4.494a.451.451 0 0 1-.442-.36l-.009-.09V2.997a.45.45 0 0 1 .45-.45h4.495a.45.45 0 0 1 .45.45v18.009Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919EAB",
    fillOpacity: 0.16,
    d: "M2.168 7.966v13.04c0 .11.09.2.2.2h4.494a.2.2 0 0 0 .2-.2V7.965a.2.2 0 0 0-.2-.2H2.368a.2.2 0 0 0-.2.2Zm8.001 3.921h4.494c.11 0 .2.09.2.2v8.916a.2.2 0 0 1-.2.2h-4.494a.2.2 0 0 1-.2-.2v-8.916c0-.11.09-.2.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#596773",
    d: "M2.418 20.955h4.394V8.015H2.418v12.94Zm7.8-.002h4.395v-8.816H10.22v8.816Zm4.895.05a.45.45 0 0 1-.45.45H10.17a.45.45 0 0 1-.45-.45v-8.916a.45.45 0 0 1 .45-.45h4.494a.45.45 0 0 1 .45.45v8.917Zm-7.8.002a.45.45 0 0 1-.45.45H2.367a.45.45 0 0 1-.441-.36l-.009-.09V7.965a.45.45 0 0 1 .45-.45h4.494a.45.45 0 0 1 .45.45v13.04Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar_chart.6d369c1483e98e6012608be781a25e66.svg";
export { ForwardRef as ReactComponent };